import { ImplementedService } from './implemented.service';
import { Observable, throwError, of } from 'rxjs';
import { map, delay, tap } from 'rxjs/operators';
import { ListObject } from '../../models/list-object.model';
import { FactoryBase } from '../../interfaces/factory-base.interface';
import { ApiService } from '../../api/services/api.service';
import { FieldHandler } from '../../models/field-handler.model';
import { ListParameters } from '../../interfaces/list-parameters.interface';

export abstract class ImplementedApiService<T, R> extends ImplementedService<T, R> {
  constructor(protected readonly apiService: ApiService, readonly mFactory: FactoryBase<T>, readonly mPath: string) {
    super(apiService, mFactory, mPath);
  }

  protected getAllFields = new FieldHandler(true);
  protected getByIdFields = new FieldHandler(true);

  public getAll(routeParams: ListParameters): Observable<ListObject<T>> {
    this.checkParameters();

    if (!this.factory.loadFromResponse) {
      return throwError("The factory doesn't have the loadFromResponse implementation.");
    }

    if (this.mockData) {
      return of(this.mockData).pipe(
        delay(this.mockDelay),
        map(
          (data) => new ListObject<T>(data, data.length),
          tap((data) => console.log('Mock index', `GET ${this.path}`, data))
        )
      );
    }

    return this.apiService
      .getList<R>(`${this.path}`, { ...routeParams, fields: this.getAllFields.toString() })
      .pipe(
        map(
          (response) =>
            new ListObject<T>(response.data.map((i) => this.factory.loadFromResponse(i) as T), response.count)
        )
      );
  }

  public getById(id: number): Observable<T> {
    this.checkParameters();

    if (!this.factory.loadFromResponse) {
      return throwError("The factory doesn't have the loadFromResponse implementation.");
    }

    if (this.mockData) {
      return of(this.mockData).pipe(
        delay(this.mockDelay),
        map((data) => data[0]),
        tap((data) => console.log('Mock get', `GET ${this.path}/${id}`, data))
      );
    }

    return this.apiService
      .getOne<R>(`${this.path}/${id}`, { fields: this.getByIdFields.toString() })
      .pipe(map((response) => this.factory.loadFromResponse(response) as T));
  }
}
